import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import ArrowBack from '@material-ui/icons/ArrowBack';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@bharatpe/bharat-ui/web/IconButton';

import { HeaderProps } from './HeaderPostPe.types';

import './HeaderPostPe.scss';

const HeaderPostPe: React.FC<HeaderProps> = ({
	title,
	subTitle,
	options,
	children,
	className,
	leftIcon,
	leftIconAction,
}) => {
	const getLeftIcon = () => {
		return (
			<IconButton edge="start" aria-label="menu" className="mr1" onClick={leftIconAction}>
				{leftIcon}
			</IconButton>
		);
	};

	return (
		<div className={clsx('header-container white-background border-box width-100 sticky top-index', className)}>
			<AppBar position="static" color="transparent" elevation={0}>
				<Toolbar>
					<div className="flex flex-center flex-justify width-100">
						<div className="flex flex-center">
							{getLeftIcon()}
							<div className="flex flex-column">
								<span className="headerPostpeText">{title}</span>
							</div>
						</div>
						{options}
					</div>
				</Toolbar>
				{children}
			</AppBar>
		</div>
	);
};

HeaderPostPe.propTypes = {
	title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
	subTitle: PropTypes.string,
	options: PropTypes.node,
	children: PropTypes.node,
	className: PropTypes.string,
	leftIcon: PropTypes.node,
};

HeaderPostPe.defaultProps = {
	subTitle: '',
	options: null,
	children: null,
	className: '',
	leftIcon: <ArrowBack className="dark" />,
	leftIconAction: undefined,
};

export default HeaderPostPe;
